import React from 'react'
import Link from 'next/link'
import Image from 'next/image'
import { Button } from '../../atoms'
import { ArrowRight } from '../../atoms/NewIcons'
import useTrans from '../../../hooks/useTrans'
import { getAltText } from '../../../utils/safe'
import { useMemo } from 'react'

const CategoriaCardHome = ({ main_image, titolo, descrizione, slug, backgroundColor, index }) => {
  const t = useTrans()
  const ariaLabel = useMemo(() => t('Scopri di più') + (titolo ? ` ${titolo}` : ''), [titolo])

  return (
    <div>
      <div className={`categoria-card-home categoria-card-home--mobile`}>
        <Link href={slug ? slug : ''}>
          <a aria-label={ariaLabel}>
            <div className="categoria-card-home__image-wrapper">
              {main_image && (
                <Image
                  className="categoria-card-home__image"
                  src={main_image.url}
                  alt={getAltText(main_image) || titolo}
                  title={titolo}
                  layout={'fill'}
                  objectFit={'cover'}
                />
              )}
            </div>
          </a>
        </Link>
        <div className="categoria-card-home__content">
          {titolo && <h3 className="categoria-card-home__title">{titolo}</h3>}
          {descrizione && (
            <p className="categoria-card-home__description categoria-card-home__description">
              {descrizione}
            </p>
          )}
          <Link href={slug ? slug : ''}>
            <Button
              href={slug ? slug : ''}
              label={ariaLabel}
              icon={<ArrowRight />}
              size="large"
              variant="ghost"
              className="categoria-card-home__cta"
            />
          </Link>
        </div>
      </div>
      <div className={`categoria-card-home categoria-card-home--desktop`}>
        {main_image && (
          <Link href={slug ? slug : ''}>
            <a className="categoria-card-home__image-cta" aria-label={ariaLabel}>
              <div className="categoria-card-home__image-wrapper">
                <Image
                  className="categoria-card-home__image"
                  src={main_image.url}
                  alt={getAltText(main_image) || titolo}
                  title={titolo}
                  layout={'fill'}
                  objectFit={'cover'}
                />
              </div>
            </a>
          </Link>
        )}
        <div className="categoria-card-home__content">
          <div className="categoria-card-home__content-cta">
            {titolo && <h3 className="categoria-card-home__title">{titolo}</h3>}
            <Link href={slug ? slug : ''}>
              <Button
                href={slug ? slug : ''}
                className="categoria-card-home__cta"
                size="large"
                responsive={true}
                variant="secondary"
                colorVariant="black"
                icon={<ArrowRight />}
                ariaLabel={ariaLabel}
              />
            </Link>
          </div>
          {descrizione && <p className="categoria-card-home__description">{descrizione}</p>}
        </div>
      </div>
    </div>
  )
}

export default CategoriaCardHome
